import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import { useAddTaskMutation, useUpdateTaskMutation } from '../../features/tasks/tasksApi';
import { useGetTeamQuery } from '../../features/team/teamApi'

function TaskForm({ editData }) {
  const { data: teamData } = useGetTeamQuery();
  const { data: projectData } = useGetProjectsQuery();
  const [addTask, { isSuccess: isAddTaskSuccess }] = useAddTaskMutation();
  const [updateTask, { isSuccess: isEditTakSuccess }] = useUpdateTaskMutation();
  const { taskId } = useParams();
  const navigate = useNavigate()
  const teamMembers = teamData || [];
  const projects = projectData || [];

  //States
  const [taskName, setTaskName] = useState("");
  const [teamMemberId, setTeamMemberId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [deadline, setDeadline] = useState("");


  //Hooks
  useEffect(() => {
    if (isAddTaskSuccess || isEditTakSuccess) {
      navigate("/tasks")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddTaskSuccess, isEditTakSuccess]);

  useEffect(() => {
    const { taskName, teamMember: { id: teamMemberId } = {}, project: { id: projectId } = {}, deadline } = editData || {};
    if (taskName && teamMemberId && projectId && deadline) {
      setTaskName(taskName);
      setTeamMemberId(teamMemberId);
      setProjectId(projectId);
      setDeadline(deadline);
    }
  }, [editData])


  //Functions
  const handleSubmit = (e) => {
    e.preventDefault();
    const filteredMember = teamMembers.find(member => member.id == teamMemberId);
    const filteredProject = projects.find(project => project.id == projectId);
    const payload = {
      taskName,
      teamMember: filteredMember,
      project: filteredProject,
      deadline
    }
    if (taskId) {
      updateTask({ id: taskId, payload });
    } else {
      addTask({ payload });
    }

  }


  //JSX
  return (
    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="fieldContainer">
          <label htmlFor="lws-taskName">Task Name</label>
          <input
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select name="teamMember" id="lws-teamMember" value={teamMemberId}
            onChange={(e) => setTeamMemberId(e.target.value)}
            required>
            <option defaultValue="" hidden >Select Name</option>
            {teamMembers.map(member => {
              const { id, name } = member;
              return (<option key={id} value={id}>{name}</option>)
            })}
          </select>
        </div>
        <div className="fieldContainer">
          <label htmlFor="lws-projectName">Project Name</label>
          <select id="lws-projectName" name="projectName" value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            required>
            <option defaultValue="" hidden >Select Project</option>
            {projects.map(project => {
              const { id, projectName } = project;
              return (<option key={id} value={id}>{projectName}</option>)
            })}
          </select>
        </div>

        <div className="fieldContainer">
          <label htmlFor="lws-deadline">Deadline</label>
          <input type="date" name="deadline" id="lws-deadline" value={deadline} onChange={(e) => setDeadline(e.target.value)} required />
        </div>

        <div className="text-right">
          <button type="submit" className="lws-submit">Save</button>
        </div>
      </form>
    </div>
  )
}

export default TaskForm